<template>



    <v-container fluid>
        <v-layout row wrap>

            <v-flex xs12>
                Payments Archive
            </v-flex>

        </v-layout>
    </v-container>



</template>


<script>

    export default {
        name: "PaymentsArchive",
        data: function () {
            return {

            }
        }


    }
</script>


<style scoped lang="scss">


</style>
